"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GLOBAL_OVERWRITE_IPFS_CODE_BY_NETWORK = exports.GENERAL_WORKER_URL_BY_NETWORK = exports.NETWORK_CONTEXT_BY_NETWORK = void 0;
const contracts_1 = require("@lit-protocol/contracts");
/**
 * Mapping of network context by network value.
 */
exports.NETWORK_CONTEXT_BY_NETWORK = {
    cayenne: contracts_1.cayenne,
    manzano: contracts_1.manzano,
    habanero: contracts_1.habanero,
    'datil-dev': contracts_1.datilDev,
    'datil-test': contracts_1.datilTest,
    datil: contracts_1.datil,
    // just use datil dev abis for custom and localhost
    custom: contracts_1.datilDev,
    localhost: contracts_1.datilDev,
};
/**
 * @deprecated Will be removed in version 7.x.
 */
exports.GENERAL_WORKER_URL_BY_NETWORK = {
    cayenne: 'https://apis.getlit.dev/cayenne/contracts',
    manzano: 'https://apis.getlit.dev/manzano/contracts',
    habanero: 'https://apis.getlit.dev/habanero/contracts',
    'datil-dev': 'https://apis.getlit.dev/datil-dev/contracts',
    'datil-test': 'https://apis.getlit.dev/datil-test/contracts',
    // just use cayenne abis for custom and localhost
    custom: 'https://apis.getlit.dev/cayenne/contracts',
    localhost: 'https://apis.getlit.dev/cayenne/contracts',
};
exports.GLOBAL_OVERWRITE_IPFS_CODE_BY_NETWORK = {
    cayenne: false,
    manzano: false,
    habanero: true,
    'datil-dev': false,
    'datil-test': false,
    datil: false,
    custom: false,
    localhost: false,
};
//# sourceMappingURL=mappers.js.map